import {
  CART_REVAMP_TRACKER_TYPE,
  EVENT_CATEGORY_FOR_USER_FLOW,
} from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

export const onTrackCartMemberLoginClick = async () => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');

  trackerService.track({
    type: CART_REVAMP_TRACKER_TYPE.CartMemberLoginClick,
    data: {
      event_category: EVENT_CATEGORY_FOR_USER_FLOW.SignUp, // Because of the button represents `Login/SignUp`, we stick to the same event category.
    },
  });
};
